export const FULL_BACKUP_WARNING =
  "此备份包含私人原文和完整本地治理数据，不适合发送给董事会 OS、合作方或公共网盘。请存放在你控制的受保护设备中。";

export const EXTERNAL_EXPORT_WARNING =
  "董事会摘要只包含当前预览中已勾选的结构化字段。已经导出的文件无法由 CEO OS 远程召回。";

export const LOCAL_SECURITY_BOUNDARY =
  "CEO OS 默认不联网发送私人内容，但浏览器扩展、拥有设备控制权的其他用户、本地恶意软件和未加密磁盘不属于 Web 应用能够完全防御的范围。";

export const NEVER_EXPORT_FIELDS = new Set([
  "rawText",
  "raw_text",
  "voiceTranscript",
  "voice_transcript",
  "privateNotes",
  "private_notes",
]);

export function containsForbiddenPrivateField(value: unknown): boolean {
  if (Array.isArray(value)) {
    return value.some(containsForbiddenPrivateField);
  }
  if (value !== null && typeof value === "object") {
    return Object.entries(value as Record<string, unknown>).some(
      ([key, entry]) => NEVER_EXPORT_FIELDS.has(key) || containsForbiddenPrivateField(entry),
    );
  }
  return false;
}

export function safeErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return `${error.name}: 操作失败；详细内容已省略以避免记录私人信息。`;
  }
  return "操作失败；详细内容已省略以避免记录私人信息。";
}
